
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ObjectTypeInfo, PageBase, T4RentalObjectService, T4SettingsService } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { CreateAddonDialog } from '../../dialogs/CreateAddonDialog/CreateAddonDialog';
import { MatDialogRef } from '@angular/material/dialog';
import { CreateSparepartsDialog } from '../../dialogs/CreateSpareparttDialog/CreateSparepartsDialog';

@Component({
  styleUrls: ['./Spareparts.css'],
  selector: 'Spareparts',
  templateUrl: './Spareparts.component.html',
})
export class SparepartsComponent extends PageBase implements OnInit {

  constructor(el: ElementRef, private route: ActivatedRoute, private svcObject: T4RentalObjectService) {
    super(el, "Spareparts");
  }

  public mySpareParts: ObjectTypeInfo[];
  public inheritedSpareParts: ObjectTypeInfo[];

  public dialogRef: MatDialogRef<CreateSparepartsDialog>;

  public async ngOnInit() {
    await this.GetSpareparts();
  }

  public async openAddon(addon: ObjectTypeInfo = null, readonly: boolean = true) {
    await this.Dialog.open(CreateSparepartsDialog, { width: '850px', data: { sparepartToChange: addon, readonly: readonly } }).afterClosed().toPromise();
    await this.GetSpareparts();
  }

  private async GetSpareparts() {
    var token = this.UI.beginLoading("T4.Settings.Spareparts.msgLoading", "Loading spareparts", null);
    var data = await this.Api.get<ObjectTypeInfo[][]>("RentalObject/GetAllSpareparts");
    this.mySpareParts = data[0];
    this.inheritedSpareParts = data[1];
    this.UI.loaderCompleted(token);
  }

  public async deleteAddon(addon: ObjectTypeInfo) {

    var d = await this.UI.confirm("T4.Settings.Spareparts.titleConfirmDelete", "Confirm deletion", "T4.Settings.Spareparts.msgConfirmDelete", "Do you want to remove this spare part?");

    if (d) {
      var deleted = await this.Api.delete<boolean>("RentalObject/DeleteAddon", { id: addon.Id });
      if (deleted) {
        this.GetSpareparts();
      }
      else {
        alert("Error, could not be deleted");
      }
    }
  }
}
